import { Card, CardContent, makeStyles } from "@material-ui/core";
import { PHOTOFORREFERRAL } from "../../../../../constants";
import { useFormikContext } from "formik";
import useLocale from "../../../../../hooks/useLocale";
import handleImageUpload from "./handleImageUpload";
import handleFileUpload from "./handleFileUpload";
import FileUpload from "../../../../../components/GovGrFileInput/FileUpload";

const useStyles = makeStyles({
  docCard: {
    margin: "1rem 0",
  },
  uploadButton: {
    margin: "1rem 0",
  },
  alert: {
    margin: "0.5rem 0",
    width: 300,
  },
});

const DocumentItem = ({
  docPerKind,
  index,
  uploadedDocumentsIds,
  imageFormatErrorText,
  setImageFormatErrorText,
  arrayHelpers,
}) => {
  const { t } = useLocale();
  const classes = useStyles();
  const { values } = useFormikContext();
  const document = values?.documents?.find(
    (doc) => doc?.doc_id === docPerKind?.doc_id
  );

  const isPhoto = docPerKind?.document.includes(PHOTOFORREFERRAL);

  const error =
    (imageFormatErrorText && isPhoto && imageFormatErrorText) ||
    (docPerKind.req_flg === 1 &&
      !uploadedDocumentsIds?.includes(docPerKind?.id) &&
      t("Required"));

  return (
    <Card key={docPerKind.id} variant="outlined" className={classes.docCard}>
      <CardContent>
        <FileUpload
          label={`${index + 1}. ${docPerKind.dscr} `}
          document={document}
          accept={isPhoto ? "image/*" : "application/pdf,image/jpeg"}
          hint={isPhoto && t("Photo Requirements")}
          errorLabel={error}
          onChange={(e) =>
            isPhoto
              ? handleImageUpload(
                  e,
                  setImageFormatErrorText,
                  arrayHelpers,
                  index,
                  docPerKind,
                  t
                )
              : handleFileUpload(e, arrayHelpers, index, docPerKind)
          }
          handleViewFile={async (e) => {
            const doc = values.documents?.find(
              (doc) => doc?.doc_id === docPerKind?.doc_id
            );

            const blob = new Blob([doc?.files[0]], {
              type: doc?.files[0].type,
            });

            let url = window.URL.createObjectURL(blob);

            window.open(url, "_blank");
          }}
          handleDeleteFile={(e) => {
            e.preventDefault();
            arrayHelpers.replace(index, null);
          }}
          uploadedFilename={values?.documents
            ?.find((uploadedDoc) => uploadedDoc?.id === docPerKind?.id)
            ?.files?.map((file) => (
              <span key={file.name}>{file.name}</span>
            ))}
        />
      </CardContent>
    </Card>
  );
};

export default DocumentItem;
